<!-- 查询车辆信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "phone": "18200946810",
                "pageNum": 1,
                "pageSize": 10
            },
            responseCode: {
                "data": {
                    "currCount": 1,
                    "recordList": [
                        {
                            "billType": 0,
                            "billName": "停车费",
                            "billCode": "201903251453353",
                            "billValue": 10.1,
                            "billSuccessDate": "20190325145335"
                        }
                    ],
                    "total": 1
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台,获取用户优惠券信息列表",
                t_url: this.commonUrls.test+"getUserCouponRecord",
                p_url: this.commonUrls.prod+"getUserCouponRecord",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'phone', info2: '是', info3: 'String', info4: '智慧停车用户手机号' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' }
                        ]
                },],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'count', info2: '是', info3: 'Integer', info4: '当前取得的记录条数' },
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '用户信息列表' },
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponName', info2: '是', info3: 'String', info4: '优惠券名称' },
                        { info1: 'serialNumber', info2: '是', info3: 'String', info4: '优惠券编码' },
                        { info1: 'couponType', info2: '是', info3: 'Integer', info4: '优惠类型' },
                        { info1: 'faceValue', info2: '是', info3: 'String', info4: '(0:免费券,1:金额扣减券,费减免固定金额结算,2:金额折扣券,车费折扣减免结算,3:金额固定值券,车费按券的固定值结算,4:时间券,时间减免后再按车费结算,5:不同计价券,按不同计价规则车费结算' },
                        { info1: 'isCover', info2: '是', info3: 'Boolean', info4: '是否可用叠加使用' },
                        { info1: 'maxCoverNum', info2: '是', info3: 'Integer', info4: '最大叠加数' },
                        { info1: 'target', info2: '是', info3: 'String', info4: '适用对象（车牌或手机号）' },
                        { info1: 'parkNames', info2: '是', info3: 'String', info4: '适用停车场' },
                        { info1: 'status', info2: '是', info3: 'String', info4: '状态：NOT_USE(未使用),LOCKED(锁定中),USED(已使用),INVALID(失效),RECOVERED(已回收' },
                        { info1: 'validFrom', info2: '是', info3: 'String', info4: '有效时间开始，格式：yyyyMMddHHmmss' },
                        { info1: 'validTo', info2: '是', info3: 'String', info4: '有效时间结束，格式：yyyyMMddHHmmss' },
                        { info1: 'useRule', info2: '是', info3: 'String', info4: '适用规则（金额可使用范围）' },
                        { info1: 'grantTime', info2: '是', info3: 'String', info4: '领券时间' },
                        { info1: 'couponPlatform', info2: '是', info3: 'Integer', info4: '券平台0：商家券 1：运营券' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/getUserCouponRecord.vue